import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class RechargeService {

  private baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }


  getTransactions(body: any) {
    return this.http.post(`${this.baseUrl}/customer/transactions/list`, body);
  }

  createRazorpayOrder(payload: { amount: number }) {
    return this.http.post(
      `${this.baseUrl}/customer/transactions/create-razorpay-order`,
      payload
    );
  }

  verifyRazorpayPayment(payload: { razorpay_order_id: string; razorpay_payment_id: string; razorpay_signature: string }) {
    return this.http.post(
      `${this.baseUrl}/customer/transactions/verify-razorpay-payment`,
      payload
    );
  }
}
